import { Box, Typography, useTheme } from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef
} from "material-react-table";
import { useMemo, useState } from "react";
import { AdminGlobalTable } from "../../../tables/AdminGlobalTable";
import { ActionCell } from "./TableCell";
import { AdminTableTopToolbar } from "../../common/AdminTableTopToolbar";
import OrgUsersRoleTable from "./OrgUserRole.table";
import { AddRoleModal } from "../../common/AddRoleModal";
import { MakeAdministratorModal } from "../../common/MakeAdministratorModal";
import ExpandButtonGroup from "../../common/ExpandButtonGroup.table";
import OrgUsersDetailsPanel from "./OrgUsersDetailsPanel";

export type TOrgUser = {
  name: string;
  email: string;
  userName: string;
  cohort: string;
  team: string;
  role: string;
  expiration: string;
  roleList?: TOrgUser[];
};
const userTableCol = (handleOpenAddRoleModal,setSelectedUser,setOpenMakeAdministratorModal,setSingleUserData) => [
  {
    accessorKey: "userName",
    header: "Username",
    size: 120,
    Cell: (cell) => {
      return <Typography fontSize="15px">{cell.row.original.name}</Typography>;
    }
  },
  {
    accessorKey: "email",
    header: "Email",
    size: 120,
    Cell: (cell) => {
      return <Typography fontSize="15px">{cell.row.original.email}</Typography>;
    }
  },
  {
    accessorKey: "created",
    header: "Joined/Invited",
    size: 120,
    Cell: (cell) => {
      const dateStr = cell.row.original.created;
      const formattedDate = dateStr
        ? new Date(dateStr).toDateString()
        : "-";
      return <Typography fontSize="15px">{formattedDate || "-"}</Typography>;
    }
  },
  {
    id: "action",
    header: "Action",
    size: 120,
    Cell: (props) =>  ActionCell({
      ...props,
      handleOpenAddRoleModal: () => handleOpenAddRoleModal(props.row.original),
      setOpenMakeAdministratorModal,
      setSingleUserData
    })
  },
] as MRT_ColumnDef<TOrgUser>[];


const OrgUserTable = ({ orgUserData,orgID }) => {
  const theme = useTheme();
  const [selectedTable, setSelectedTable] = useState("Roles");
  const [openAddRoleModal, setOpenAddRoleModal] = useState(false);
  const [openMakeAdministratorModal, setOpenMakeAdministratorModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState<TOrgUser | null>(null);
  const [singleUserData,setSingleUserData] = useState({});

  const handleOpenAddRoleModal = (user: TOrgUser) => {
    setSelectedUser(user);
    setOpenAddRoleModal(true);
  };

  const handleCloseAddRoleModal = () => {
    setSelectedUser(null);
    setOpenAddRoleModal(false);
  };
  const handleCloseMakeAdministratorModal = () => {
    setOpenMakeAdministratorModal(false);
  };
  const columns = useMemo<MRT_ColumnDef<TOrgUser>[]>(
      () => userTableCol(handleOpenAddRoleModal,setSelectedUser,setOpenMakeAdministratorModal,setSingleUserData),
      []
    ); 
  return (
    <>
      <AddRoleModal
        selectedUser={selectedUser}
        open={openAddRoleModal}
        handleClose={handleCloseAddRoleModal}
        source="Org"
      />
      <MakeAdministratorModal
       open={openMakeAdministratorModal}
       handleClose={handleCloseMakeAdministratorModal}
       singleUserData={singleUserData}
       orgID={orgID}
      />
    <Box
      sx={{
        'tbody tr:has(> td[colspan]:empty)': {
          display: 'none !important',
        },
      }}
    >
      <AdminGlobalTable
        columns={columns}
        data={orgUserData}
        config={{
          enablePagination: true,
          enableRowVirtualization: false,
          enableColumnVirtualization: false,
          enableSelectAll: true,
          enableStickyHeader: true,
          //enableRowSelection: true,
          
          // muiSelectCheckboxProps: { 
          //   color: "secondary",
          //   sx:{ 
          //     '& input[type="checkbox"]': {
          //     height: '44px !important',
          //   },}
          //  },
          muiTableContainerProps: {
            sx: {
              maxHeight: "calc(100vh - 585px)",
              minHeight: "calc(100vh - 585px)",
            },
          },
          muiTableBodyRowProps: () => ({
            hover: false,
            sx: {
              height: "78px",
              backgroundColor: "transparent",
              ":hover": { backgroundColor: theme.custom.hoverOptionColor },
            },
          }),
          muiExpandButtonProps: ({ row }) => {
            return {
              children: (
                <ExpandButtonGroup
                  row={row}
                  selectedTable={selectedTable}
                  setSelectedTable={setSelectedTable}
                  buttons={[
                    { key: "Roles", label: "Roles" },
                    { key: "Licenses", label: "Licenses" },
                  ]}
                />
              ),
            };
          },
          
          renderDetailPanel: ({ row }) => {
            return (
              <Box sx={{ marginLeft: "30px" }}>
                <OrgUsersDetailsPanel
                  row={row}
                  selectedTable={selectedTable}
                />
              </Box>
            );
          },
          renderTopToolbarCustomActions: ({ table }) => (
            <AdminTableTopToolbar
              title="Organizations Users List"
              table={table}
              data={orgUserData}
            />
          ),
        }}
      />
    </Box>
    </>
  );
};

export default OrgUserTable;
